'use strict';

/**
 * @abstract
 */
ngtk.controller.PaginationTrait = Class({

    construct: Class.traitConstructor,

    _paginatedModel: null,
    _perPage: undefined,
    _perPageOptions: undefined,

    /**
     * @param {ngtk.model.SlicedList} model
     * @protected
     */
    _setPaginatedModel: function(model) {
        this._paginatedModel = model;
        if (this._perPageOptions) {
            this._initPerPageOptions();
        }
        if (this._perPage) {
            this._paginatedModel.setPerPage(this._perPage);
        }
        if (typeof this['$state'] !== 'undefined' && typeof this['$stateParams'] !== 'undefined' && this.$stateParams.page) {
            this._paginatedModel.setPage(this.$stateParams.page);
        }
        this['$scope'].loadPage = this._loadPage.bind(this);
        return this;
    },

    _initPerPageOptions: function() {
        this.$scope.perPage = {
            current: this._getPerPageCookieValue() || this._perPage,
            options: this._perPageOptions.options
        };
        this._perPage = this.$scope.perPage.current;
        this.$scope.$watch('perPage.current', function(newValue) {
            if (newValue != this._perPage) {
                this._setPerPage(newValue);
                this._setPerPageCookieValue(newValue);
                this._loadPage();
            }
        }.bind(this));
    },

    _getPerPageCookieValue: function() {
        if (typeof this._perPageOptions['cookie'] !== 'undefined') {
            return this._getCookieService()(this._perPageOptions.cookie);
        } else {
            return undefined;
        }
    },

    _setPerPageCookieValue: function(value) {
        if (typeof this._perPageOptions['cookie'] !== 'undefined') {
            this._getCookieService()(this._perPageOptions.cookie, value);
        }
    },

    _getCookieService: function() {
        return typeof this['ipCookie'] !== 'undefined' ? this['ipCookie'] : angular.noop;
    },

    /**
     * @param {int} per_page
     * @protected
     */
    _setPerPage: function(per_page) {
        this._perPage = per_page;
        if (this._paginatedModel) {
            this._paginatedModel.setPerPage(per_page);
        }
    },

    /**
     * @param {int=} page
     * @protected
     */
    _loadPage: function(page) {
        return this._paginatedModel.load(page).then(function(result) {
            this._onPageLoaded();
            return result;
        }.bind(this));
    },

    /**
     * @protected
     */
    _onPageLoaded: function() {
        if (typeof this['$state'] !== 'undefined' && typeof this['$stateParams'] !== 'undefined') {
            this.$stateParams.page = this._paginatedModel.getPage();
            this.$state.transitionTo(this.$state['current'], this.$stateParams, {
                reload: false,
                inherit: false,
                notify: false
            });
        }
    }

});
